module.exports = __webpack_public_path__ + "img/37.11d77cb6.jpg";